import type { FC } from 'react';
import React from 'react';

import { Box } from '@mui/material';

import { ClockAlarmSmallIcon } from '@setup/svg-icons/svg-icons';
import { MuiTooltip } from '@shared/ui-kit';

type PropsType = {
  reminderText: string;
};
export const ReminderTooltipForDocumentsModal: FC<PropsType> = ({ reminderText }) => {
  return (
    <MuiTooltip title={reminderText} color="dark">
      <Box>
        <ClockAlarmSmallIcon />
      </Box>
    </MuiTooltip>
  );
};
